
    <div class="row" [hidden]="msgHead.msg == ''">
        <div class="col-lg-8 col-md-6 col-xs-12">
            <alert [alert]="msgHead"></alert>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                        <div class="form-group">
                            <p class="custom-label">Domain Name</p>
                            <input type="text" [(ngModel)]="data.domainName" formControlName="domainName" class="form-control" placeholder="Domain Name" title="Domain Name">
                        </div>
                        <div class="form-group">
                            <p class="custom-label">Email</p>
                            <input type="text" [(ngModel)]="data.name" formControlName="email" class="form-control" placeholder="Email" title="Email">
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
            <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
            <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  